<template>
    <div class="IperMatrizPeligrosOpcionesDescargarExcel">
        <div class="bg-light m-4 p-3 rounded border-orange d-none">
            <div class="col-md-12 mt-2">
                <!-- MATRIZ DE PELIGROS -->
                <table class="table_excel table-bordered rounded" FRAME="void" RULES="all" :id="'matrizPeligros-' + id">
                    <thead>
                        <tr class="font-weight-bold">
                            <th colspan="2" rowspan="2" align="center"
                                style="font-family: Arial; font-size: 10pt; vertical-align: middle; text-align: center;">
                                <p class="mt-3">LOGO</p>
                            </th>
                            <th colspan="24" align="center"
                                style="font-family: Arial; font-size: 10pt; vertical-align: middle; text-align: center;">
                                MATRIZ IDENTIFICACIÓN DE PELIGROS, EVALUACIÓN Y VALORACIÓN DE LOS RIESGOS
                            </th>
                        </tr>

                        <tr class="font-weight-bold">
                            <th colspan="24" align="center"
                                style="font-family: Arial; font-size: 10pt; vertical-align: middle; text-align: center;">
                                F-H&amp;S-01 Versión 1, Vigencia 13-04-2016
                            </th>
                        </tr>
                        <tr>
                            <th colspan=" 2" style="font-family: Arial; font-size: 10pt; text-align: left;">
                                Nombre de la Empresa:
                            </th>
                            <td colspan="2"
                                style="background: #fff !important; font-family: Arial; font-size: 10pt; text-align: left;">
                                {{ empresa.nombre }}
                            </td>
                            <th colspan="2" style="font-family: Arial; font-size: 10pt; text-align: left;">
                                Actividad Económica:
                            </th>
                            <td colspan="2"
                                style="background: #fff !important; font-family: Arial; font-size: 10pt; text-align: left;">
                                {{ empresa.actividad }}
                            </td>
                            <th colspan="2" style="font-family: Arial; font-size: 10pt; text-align: left;">
                                Nombre del Centro de Trabajo:
                            </th>
                            <td colspan="8"
                                style="background: #fff !important; font-family: Arial; font-size: 10pt; text-align: left;">
                                {{ empresa.centroTrabajo }}
                            </td>
                            <th colspan="2" style="font-family: Arial; font-size: 10pt; text-align: left;">
                                Ciudad:
                            </th>
                            <td colspan="2"
                                style="background: #fff !important; font-family: Arial; font-size: 10pt; text-align: left;">
                                {{ empresa.ubicacion.ciudad }}
                            </td>
                            <th colspan="2" style="font-family: Arial; font-size: 10pt; text-align: left;">
                                Departamento:
                            </th>
                            <td colspan="2"
                                style="background: #fff !important; font-family: Arial; font-size: 10pt; text-align: left;">
                                {{ empresa.ubicacion.departamento }}
                            </td>
                        </tr>
                        <tr>
                            <th colspan="2" style="font-family: Arial; font-size: 10pt; text-align: left;">
                                Número de Trabajadores:
                            </th>
                            <td colspan="2"
                                style="background: #fff !important; font-family: Arial; font-size: 10pt; text-align: left;">
                                {{ empresa.numeroTrabajadores }}
                            </td>
                            <th colspan="2" style="font-family: Arial; font-size: 10pt; text-align: left;">
                                Clase de Riesgo:
                            </th>
                            <td colspan="2"
                                style="background: #fff !important; font-family: Arial; font-size: 10pt; text-align: left;">
                                <div v-if="empresa.claseRiesgo">
                                    <div v-for="(item, index) of empresa.claseRiesgo" :key="index">
                                        {{ item }}
                                    </div>
                                </div>
                                <div v-if="(typeof empresa.claseRiesgo)">
                                    N/A
                                </div>
                            </td>
                            <th colspan="2" style="font-family: Arial; font-size: 10pt; text-align: left;">
                                Fecha de Actualización:
                            </th>
                            <td colspan="8"
                                style="background: #fff !important; font-family: Arial; font-size: 10pt; text-align: left;">
                                {{ empresa.fechaActualizacion }}
                            </td>
                            <th colspan="2" style="font-family: Arial; font-size: 10pt; text-align: left;">
                                Visita Atendida Por:
                            </th>
                            <td v-if="empresa.visita != null" colspan="2"
                                style="background: #fff !important; font-family: Arial; font-size: 10pt; text-align: left;">
                                {{ empresa.visita }}
                            </td>
                            <!-- <td v-if="empresa.visita == null" colspan="2"
                                style="font-family: Arial; font-size: 10pt; text-align: left;">SOFU
                                BIC S.A.S</td> -->
                            <th colspan="2" style="font-family: Arial; font-size: 10pt; text-align: left;">
                                Dirección:
                            </th>
                            <td colspan="2"
                                style="background: #fff !important; font-family: Arial; font-size: 10pt; text-align: left;">
                                {{ empresa.direccion }}
                            </td>
                        </tr>
                        <tr>
                            <th colspan="26"></th>
                        </tr>
                        <tr>
                            <th rowspan="2"
                                style="background: #99CCFF; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                PROCESO, PUESTO O SECTOR ECONÓMICO
                            </th>
                            <th rowspan="2"
                                style="background: #99CCFF; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                ZONA / LUGAR
                            </th>
                            <th rowspan="2"
                                style="background: #99CCFF; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                ACTIVIDADES
                            </th>
                            <th rowspan="2"
                                style="background: #99CCFF; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                TAREAS
                            </th>
                            <th rowspan="2"
                                style="background: #99CCFF; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                TAREA RUTINARIO (SI O NO)
                            </th>
                            <th colspan="2"
                                style="background: #C0C0C0; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                PELIGROS
                            </th>
                            <th rowspan="2"
                                style="background: #CCFFFF; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                EFECTOS POSIBLES
                            </th>
                            <th colspan="3"
                                style="background: #FFCC99; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                CONTROLES EXISTENTES
                            </th>
                            <th colspan="7"
                                style="background: #CCFFFF; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                EVALUACIÓN DEL RIESGO
                            </th>
                            <th colspan="1"
                                style="background: #CCCCFF; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                VALORACIÓN DEL RIESGO
                            </th>
                            <th colspan="2"
                                style="background: #FFFF99; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                CRITERIOS PARA ESTABLECER CONTROLES
                            </th>
                            <th colspan="5"
                                style="background: #FFCC99; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                MEDIDAS DE INTERVENCIÓN
                            </th>
                        </tr>
                        <tr>
                            <th
                                style="background: #C0C0C0; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                DESCRIPCIÓN
                            </th>
                            <th
                                style="background: #C0C0C0; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                CLASIFICACIÓN
                            </th>
                            <th
                                style="background: #FFCC99; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                FUENTE
                            </th>
                            <th
                                style="background: #FFCC99; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                MEDIO
                            </th>
                            <th
                                style="background: #FFCC99; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                INDIVIDUO
                            </th>
                            <th
                                style="background: #CCFFFF; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                <p style=" padding-right: 20px;">
                                    NIVEL DE DEFICIENCIA
                                    (ND)
                                </p>
                            </th>
                            <th
                                style="background: #CCFFFF; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                <p style=" padding-right: 20px;">NIVEL DE EXPOSICIÓN (NE)
                                </p>
                            </th>
                            <th
                                style="background: #CCFFFF; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                <p style=" padding-right: 20px;">NIVEL DE PROBABILIDAD
                                    (ND*NE)</p>
                            </th>
                            <th
                                style="background: #CCFFFF; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                <p style=" padding-right: 20px;">INTERPRETACIÓN DEL NIVEL DE
                                    PROBABILIDAD</p>
                            </th>
                            <th
                                style="background: #CCFFFF; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                <p style=" padding-right: 20px;">NIVEL DE CONSECUENCIA</p>
                            </th>
                            <th
                                style="background: #CCFFFF; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                <p style=" padding-right: 20px;">NIVEL DE RIESGO E
                                    INTERVENCIÓN (NR)</p>
                            </th>
                            <th
                                style="background: #CCFFFF; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                <p style=" padding-right: 20px;">INTERPRETACIÓN DEL NIVEL DE
                                    RIESGO (NR)</p>
                            </th>
                            <th
                                style="background: #CCCCFF; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                ACEPTABILIDAD DEL RIESGO
                            </th>
                            <th
                                style="background: #FFFF99; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                Nº EXPUESTOS
                            </th>
                            <th
                                style="background: #FFFF99; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                PEOR CONSECUENCIA
                            </th>
                            <!-- MEDIDAS DE INTERVENCIÓN -->
                            <th
                                style="background: #FFCC99; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                ELIMINACIÓN
                            </th>
                            <th
                                style="background: #FFCC99; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                SUSTITUCIÓN
                            </th>
                            <th
                                style="background: #FFCC99; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                CONTROLES DE INGENIERÍA
                            </th>
                            <th
                                style="background: #FFCC99; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                CONTROLES ADMINISTRATIVOS, SEÑALIZACIÓN, ADVERTENCIA
                            </th>
                            <th
                                style="background: #FFCC99; font-weight: bold; color: #000000; font-family: Arial; font-size: 10pt; text-align: center; vertical-align: middle;">
                                EQUIPOS / EPP
                            </th>
                        </tr>
                    </thead>
                    <tbody style="background: transparent;">
                        <tr v-for="(item, index) of matriz" :key="index"
                            style="text-align: center; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                            <!-- INFORMACIÓN PROCESO -->
                            <td
                                style="text-align: center; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                {{ item.proceso_riesgo }}
                            </td>
                            <!-- INFORMACIÓN ZONA -->
                            <td
                                style="text-align: center; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                {{ item.zona }}
                            </td>
                            <!-- INFORMACIÓN ACTIVIDADES -->
                            <td
                                style="text-align: center; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                {{ item.actividades }}
                            </td>
                            <!-- INFORMACIÓN TAREAS -->
                            <td
                                style="text-align: center; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                <div v-if="!Array.isArray(item.tareas)">
                                    {{ item.tareas }}
                                </div>
                                <div v-else v-for="(u_tarea, index) of item.tareas" :key="index.u_tarea">
                                    {{ u_tarea }}
                                </div>
                            </td>
                            <!-- INFORMACIÓN RUTINARIO -->
                            <td
                                style="text-align: center; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                <div style="text-align: center !important">
                                    <div v-if="item.rutinario === true">Sí</div>
                                    <div v-else>No</div>
                                </div>
                            </td>
                            <!-- INFORMACIÓN DESCRIPCIÓN -->
                            <td style="text-align: left; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                {{ item.descripcion }}
                            </td>
                            <!-- INFORMACIÓN CLASIFICACIÓN -->
                            <td
                                style="display: table-cell !important; vertical-align: middle !important; font-family: Arial; font-size: 10pt;">
                                <div style="text-align: center !important; font-family: Arial; font-size: 10pt;">
                                    <div v-if="(item.clasificacion != '' ||
                                        item.clasificacion != undefined) &&
                                        item.tipo
                                    ">
                                        {{ item.clasificacion }} <br> ({{ item.tipo }})
                                    </div>
                                    <div v-if="(item.clasificacion != '' ||
                                        item.clasificacion != undefined) &&
                                        item.subti
                                    ">
                                        {{ item.clasificacion }} <br>
                                        ({{ item.subti }})
                                    </div>
                                    <div v-if="(item.clasificacion != '' ||
                                        item.clasificacion != undefined) &&
                                        item.otro_subti
                                    ">
                                        {{ item.clasificacion }} <br>
                                        ({{ item.otro_subti }})
                                    </div>
                                </div>
                            </td>
                            <td style="text-align: left; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                <!-- EFECTOS POSIBLES -->
                                <div v-for="(efecto, index) in item.efectos" :key="index.efecto">
                                    <p v-if="efecto != ''">{{ efecto }}</p>
                                </div>
                            </td>
                            <td style="text-align: left; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                <!-- CONTROLES EXISTENTES - FUENTE -->
                                <div v-for="(fuente, index) in item.control_fuente" :key="index.fuente">
                                    <p v-if="fuente != ''">{{ fuente }}</p>
                                </div>
                            </td>
                            <td style="text-align: left; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                <!-- CONTROLES EXISTENTES - MEDIO -->
                                <div v-for="(medio, index) in item.control_medio" :key="index.medio">
                                    <p v-if="medio != ''">{{ medio }}</p>
                                </div>
                            </td>
                            <td style="text-align: left; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                <!-- CONTROLES EXISTENTES - INDIVIDUO -->
                                <div v-for="(individuo,
                                    index) in item.control_individuo" :key="index.individuo">
                                    <p v-if="individuo != ''">{{ individuo }}</p>
                                </div>
                            </td>
                            <!-- NIVEL DE DEFICIENCIA -->
                            <td
                                style="text-align: center; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                {{ item.nivel_eficiencia }}
                            </td>
                            <!-- NIVEL DE EXPOSICIÓN -->
                            <td
                                style="text-align: center; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                {{ item.nivel_exposicion }}
                            </td>
                            <!-- NIVEL DE PROBABILIDAD -->
                            <td
                                style="text-align: center; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                {{ item.nivel_probabilidad }}
                            </td>
                            <td
                                style="text-align: center; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                <!-- INTERPRETACIÓN DEL NIVEL DE PROBABILIDAD -->
                                <div v-if="item.interpretacion != ''">
                                    {{ item.interpretacion }}
                                </div>
                            </td>
                            <!-- NIVEL DE CONSECUENCIA -->
                            <td
                                style="text-align: center; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                {{ item.nivel_consecuencia }}
                            </td>
                            <!-- NIVEL DE RIESGO (NR) E INTERVENCIÓN -->
                            <td
                                style="text-align: center; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                {{ item.nivel_riesgo }}
                            </td>
                            <!-- INTERPRETACIÓN DEL NR -->
                            <td
                                style="display: table-cell !important; vertical-align: middle !important; font-family: Arial; font-size: 10pt;">
                                {{ item.interpretacion_nr ? item.interpretacion_nr : "-" }}
                            </td>
                            <td v-if="item.aceptabilidad != '' &&
                                item.aceptabilidad == 'No Aceptable'
                            "
                                style="background: #ff0000 !important; color: white; text-align: center; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                <!-- ACEPTABILIDAD DEL RIESGO -->
                                <div v-if="item.aceptabilidad != '' &&
                                    item.aceptabilidad == 'No Aceptable'
                                ">
                                    <b>{{ item.aceptabilidad }}</b>
                                </div>
                            </td>
                            <td v-if="item.aceptabilidad != '' &&
                                item.aceptabilidad ==
                                'Aceptable con Control Específico'
                            "
                                style="background: #ffff00 !important; text-align: center; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                <div v-if="item.aceptabilidad != '' &&
                                    item.aceptabilidad ==
                                    'Aceptable con Control Específico'
                                ">
                                    <b>{{ item.aceptabilidad }}</b>
                                </div>
                            </td>
                            <td v-if="item.aceptabilidad != '' &&
                                item.aceptabilidad == 'Mejorable'
                            "
                                style="background: #92d050 !important; text-align: center; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                <div v-if="item.aceptabilidad != '' &&
                                    item.aceptabilidad == 'Mejorable'
                                ">
                                    <b>{{ item.aceptabilidad }}</b>
                                </div>
                            </td>
                            <td v-if="item.aceptabilidad != '' &&
                                item.aceptabilidad == 'Aceptable'
                            "
                                style="background: #92d050 !important; text-align: center; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                <div v-if="item.aceptabilidad != '' &&
                                    item.aceptabilidad == 'Aceptable'
                                ">
                                    <b>{{ item.aceptabilidad }}</b>
                                </div>
                            </td>
                            <!-- NÚMERO DE EXPUESTOS -->
                            <td
                                style="text-align: center; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                {{ item.num_expuestos }}
                            </td>
                            <!-- PEOR CONSECUENCIA -->
                            <td
                                style="display: table-cell !important; vertical-align: middle !important; font-family: Arial; font-size: 10pt;">
                                {{
                                    item.peor_consecuencia }}</td>
                            <!-- MEDIDAS DE INTERVENCIÓN -->
                            <td style="text-align: left; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                <div v-if="!Array.isArray(item.eliminacion)">
                                    {{ item.eliminacion }}
                                </div>
                                <!-- ELIMINACIÓN -->
                                <div v-else v-for="(u_eli, index) of item.eliminacion" :key="index.u_eli">
                                    {{ u_eli }}
                                </div>
                            </td>
                            <td style="text-align: left; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                <!-- SUSTITUCIÓN -->
                                <div v-if="!Array.isArray(item.sustitucion)">
                                    {{ item.sustitucion }}
                                </div>
                                <div v-else v-for="(u_susti, index) of item.sustitucion" :key="index.u_susti">
                                    {{ u_susti }}
                                </div>
                            </td>
                            <td style="text-align: left; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                <!-- CONTROLES DE INGENIERÍA -->
                                <div v-if="!Array.isArray(item.controles_ing)">
                                    {{ item.controles_ing }}
                                </div>
                                <div v-else v-for="(u_ctring, index) of item.controles_ing" :key="index.u_ctring">
                                    {{ u_ctring }}
                                </div>
                            </td>
                            <td style="text-align: left; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                <!-- CONTROLES ADMINISTRATIVOS, SEÑALIZACIÓN, ADVERTENCIA -->
                                <div v-if="!Array.isArray(item.controles)">
                                    {{ item.controles }}
                                </div>
                                <div v-else v-for="(u_ctr, index) of item.controles" :key="index.u_ctr">
                                    {{ u_ctr }}
                                </div>
                            </td>
                            <td style="text-align: left; vertical-align: middle; font-family: Arial; font-size: 10pt;">
                                <!-- EPP -->
                                <div v-if="!Array.isArray(item.equipos)">
                                    {{ item.equipos }}
                                </div>
                                <div v-else v-for="(u_equipo, index) of item.equipos" :key="index.u_equipo">
                                    {{ u_equipo }}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <!-- CONTROL DE CAMBIOS -->
                <table class="table table-bordered mt-3" :id="'controlCambios-' + id">
                    <thead>
                        <tr>
                            <th scope="col" class="thead-table-orange">Tipo de Cambio</th>
                            <th scope="col" class="thead-table-orange">Fecha</th>
                            <th scope="col" class="thead-table-orange">Observación</th>
                            <th scope="col" class="thead-table-orange">Usuario</th>
                        </tr>
                    </thead>
                    <template v-if="controlCambios.length > 0">
                        <tbody v-for="(item) of controlCambios" :key="item.id">
                            <tr class="text-center" style="background: #fff;">
                                <td
                                    style="font-family: Arial !important; font-size: 10pt !important; vertical-align: middle !important; text-align: center !important;">
                                    {{ item.tipoCambio }}
                                </td>
                                <td
                                    style="font-family: Arial !important; font-size: 10pt !important; vertical-align: middle !important; text-align: center !important;">
                                    {{ item.fechaCambio }}
                                </td>
                                <td style="font-family: Arial !important; font-size: 10pt !important; vertical-align: middle !important; text-align: center !important;"
                                    v-if="item.observacionCambio != ''">
                                    {{ item.observacionCambio }}
                                </td>
                                <td style="font-family: Arial !important; font-size: 10pt !important; vertical-align: middle !important; text-align: center !important;"
                                    v-if="item.observacionCambio == ''">
                                    Sin Observación
                                </td>
                                <td style="font-family: Arial !important; font-size: 10pt !important; vertical-align: middle !important; text-align: center !important;"
                                    v-if="(typeof item.correoUsuario === 'undefined')">
                                    Versión Anterior
                                </td>
                                <td style="font-family: Arial !important; font-size: 10pt !important; vertical-align: middle !important; text-align: center !important;"
                                    v-else-if="item.correoUsuario != ''">
                                    {{ item.correoUsuario }}
                                </td>
                            </tr>
                        </tbody>
                    </template>
                    <template v-else>
                        <tr class="text-center" style="background: #fff;">
                            <td colspan="4"
                                style="font-family: Arial !important; font-size: 10pt !important; vertical-align: middle !important; text-align: center !important;">
                                No hay registros de Control de Cambios para este
                                <b>Centro de Trabajo</b>.
                            </td>
                        </tr>
                    </template>
                </table>
            </div>
        </div>
        <a v-if="$store.state.global_privilegio_matriz_peligro.descargar_excel" type="button" :id="'matriz-' + id"
            class="btn btn-success ml-3 d-none" href="javascript:void(0)" @click="descargarExcel()">
            Descargar Excel
        </a>
        <ObtenerMatriz :id="id" @matriz="obtenerMatriz" />
    </div>
</template>

<script>
import { firebase, db } from '@/firebase';
import ObtenerMatriz from '../../Acciones/ObtenerMatriz.vue';

export default {
    name: "IperMatrizPeligrosOpcionesDescargarExcel",

    components: {
        ObtenerMatriz
    },

    props: {
        id: String
    },

    data() {
        return {
            empresa: {
                nombre: "",
                sector: "",
                actividad: "",
                claseRiesgo: [],
                nit: "",
                centroTrabajo: "",
                ubicacion: {
                    pais: "",
                    departamento: "",
                    ciudad: "",
                },
                numeroTrabajadores: "",
                fechaActualizacion: "",
                responsable: "",
                esBaja: null,
                visita: "",
                evaluacion: "",
            },
            matriz: [],
            controlCambios: []
        }
    },

    methods: {
        async obtenerMatriz(data) {
            this.empresa = data.empresa;
            this.matriz = data.matriz;
            this.controlCambios = data.controlCambios;
            const docRef = db.collection("historial_descarga").doc();
            const id = docRef.id;
            await db.collection("historial_descarga").doc(id).set({
                correoUsuario: this.$store.state.email_session,
                idCentroTrabajo: this.id,
                registro: {
                    creacion: firebase.firestore.FieldValue.serverTimestamp(),
                },
            });
            setTimeout(() => {
                document.getElementById("matriz-" + this.id).click();
            }, 500)
        },

        descargarExcel() {  
            const tableMatriz = document.getElementById(`matrizPeligros-${this.id}`);
            const tableCambios = document.getElementById(`controlCambios-${this.id}`);
            this.$store.state.descargarExcelMatriz(tableMatriz, tableCambios, `MATRIZ DE PELIGROS - ${this.empresa.centroTrabajo}.xlsx`);
            this.$emit("descargarExcel", false);
        },
    }
}
</script>

<style scoped>
.thead-table-orange {
    background-color: #ee8813 !important;
    color: #ffffff !important;
    background-image: linear-gradient(#e8640c, #f39200, #ff9900) !important;
    font-family: Arial !important;
    font-size: 10pt !important;
    vertical-align: middle !important;
    text-align: center !important;
}
</style>